import moment from "moment";
import config from "config/config";
import { default as getCompanyWideAlerts } from "service/CSRAdminAlerts/GetAlerts";
import { convertToTitleCase } from "js/formatting";

export const getCompanyWideAlertForCarousel = async (userView) => {
  let companyWideAlert = [];
  await getCompanyWideAlerts()
    .then((response) => {
      if (response && response?.activeAlerts?.length > 0) {
        companyWideAlert = response?.activeAlerts
          .filter(
            (a) =>
              moment(a.startDate) <= moment() &&
              a.group?.toLowerCase() === "companywide"
          )
          .map((alert) => {
            return {
              ...alert,
              title: convertToTitleCase(alert?.title),
              iconBorder: "ui-icon-border-good",
              detail: alert.message,
            };
          });
      }
    })
    .catch((error) => {
      console.error(error);
    });
  return companyWideAlert?.slice(0, parseInt(config.ALERTS_COUNT));
};
